import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../GlobalServices/Destinations/Destinations.css";

const SMwhyBBT = () => {
  return (
    <>
      <div className="Destination">
        <div className="container ServiceOffering hwybbt">
          <div className="row">
            <div className="col-md-12 mt-md-5">
              <div className="d-flex justify-content-center align-items-center flex-column">
                <h1 className="headings text-center">
                  <span>Why Choose </span> Blueberry Travels
                </h1>
                {/* <p className="heading-para grotesk-headings text-center">
                                    Blueberry Travel has made its way towards more than 30 strategic locations globally, offering top-tier travel services wherever your business journey takes you. From crowded cities to growing business hubs, we guarantee a smooth and flawless experience tailored to each unique market’s needs. Join us as we redefine business travel around the world!
                                </p> */}
              </div>
            </div>
          </div>
          <div className="row px-lg-5 px-md-0 px-4 mlTab">
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3 d-flex justify-content-center">
              <div className="DT-box1 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/smOne.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head">
                      PERSONALIZED SOLUTIONS
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      At Blueberry Travels, we specialize in designing
                      customized travel experiences that align with your
                      company’s goals, ensuring every trip is productive and
                      fun.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box2">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/smTwo.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head">
                      EXPERT GUIDANCE
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      To save you time and money, our dedicated travel experts
                      provide round-the-clock assistance, offering personalized
                      solutions to keep your business travel on track.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 mt-md-5 mt-3  d-flex justify-content-center">
              <div className="DT-box1 DT-box3 ">
                <div className="row">
                  <div className="col-md-12">
                    <div className="Destinations-img d-flex justify-content-center">
                      <LazyLoadImage
                        src="https://blueberrywebsites.azureedge.net/bbt/images/smThree.svg"
                        alt=""
                        className="img-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-md-12 p-4">
                    <h5 className="headings text-center desti-head">
                      COST-EFFECTIVE TRAVEL
                    </h5>
                    <p className="mt-3 text-center desti-para grotesk-headings">
                      We optimize your travel budget by supporting the best
                      vendor negotiations, reducing unnecessary costs, and
                      ensuring your travel meets all the financial goals.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SMwhyBBT;
